// ============================================================
// rhythmUtils.ts
// ============================================================
// Non-component helpers extracted from RhythmInputPanel to fix
// Vite Fast Refresh (component files must only export components).
// ============================================================

import type { RhythmSlot } from '../../core/types';

export function slotsToPositions(slots: RhythmSlot[]): number[] {
  return slots.map((s) => s.position);
}
